import React from 'react';
import { connect } from 'react-redux';
import {msg} from "constants/message";
import {ShowIf} from 'components/utils';
import {Link} from 'react-router';
import classnames from 'classnames';
import {validatable} from 'components/utils';

class AutoCompleteSearch extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      value: this.props.value,
      searching: false,
      openSuggest: false,
      result: [],
      page: {
        totalElements: 0
      },
      isValid: true
    }
  }

  validate() {
    if (!this.state.value.trim()) {
      this.setState({
        isValid: false
      });
      this.textInput.focus();
      return false;
    } else {
      this.setState({
        isValid: true
      });
      return true;
    }
  }

  handleBlur() {
    setTimeout(() => {
      this.setState({
        openSuggest: false
      });
    }, 500);
  }

  handleTyping(e) {
    let value = e.target.value;

    if (this.typingTimeout) {
      clearTimeout(this.typingTimeout);
    }

    if (!value) {
      this.state.openSuggest = false;
    } else {
      this.setState({
        value
      });

      this.typingTimeout = setTimeout(() => {
        this.setState({searching: true});
        this.props.onSearch(value).then(response => {
          if (response != null) {
            this.setState({
              result: response.result,
              page: response.page,
              openSuggest: true,
              searching: false
            });
          } else {
            this.setState({
              result: [],
              searching: false,
              page: { totalElements: 0 }
            });
          }
        }).catch(err => {});
      }, 1000);
    }
    this.props.onChange(value);
  }

  chonCongDan(item) {
    this.props.dispatch({
      type: 'CHON_CONG_DAN',
      data: item,
      index: this.props.index
    });
    this.state.openSuggest = false;
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.value != nextProps.value) {
      this.setState({
        value: nextProps.value
      });
    }
  }

  viewAllResult(keyword) {
    this.props.dispatch({
      type: 'TOGGLE_DIALOG',
      data: {
        name: 'PopupViewAllResult',
        status: true,
      },
      keyword: keyword,
      index: this.props.index
    });

    this.state.openSuggest = false;
  }

  render() {
    return (
      <div className="col-input autocomplete-box">
        <label className="pt-label wrap-autocomplete">
          <span className="val-title">{this.props.label}
            <ShowIf condition={this.props.isRequired}>
              <span className="text-required pt-text-muted"> *</span>
            </ShowIf>
          </span>

          <input ref={(input) => { this.textInput = input; }}
            className={classnames('pt-input', {
              'bd-timkiem': !this.props.showField,
              'tt-loading': this.props.searching,
              'pt-intent-danger': (!this.state.isValid && !this.state.value.trim())
            })}
            maxLength={this.props.maxLength}
            value={this.state.value} onBlur={this.handleBlur.bind(this)}
            onChange={this.handleTyping.bind(this)} type="text" autoComplete = "off"
            name={this.props.name}
            placeholder={ 'Vui lòng tìm kiếm' }
            disabled={ this.props.disabled }
          />
          <ShowIf condition={!this.state.searching}>
            <Link onClick={(!this.props.idDonCD && !this.props.showField)  ? this.viewAllResult.bind(this, this.state.value) : null} className="search-autocomplete"></Link>
          </ShowIf>
          <ShowIf condition={!this.state.isValid && !this.state.value.trim()}>
            <div className="pt-form-helper-text">{msg.messageDefault}</div>
          </ShowIf>
        </label>
        <div className="autocomplete-container">
          <ShowIf condition={this.state.openSuggest}>
            <ul>
              {
                this.state.result.map((item, i) => {
                  return (
                    <li key={i} className="item-person" onClick={this.chonCongDan.bind(this, item)}>
                      <div className="list-items">
                        <p className="mb10 item-header">{item.hoVaTen}</p>
                        <p className="mb10 item-content"><span className="title-content">CMND:&nbsp;</span>{item.soCMNDHoChieu}</p>
                        <p className="mb10 item-content"><span className="title-content">Địa chỉ:&nbsp;</span>{item.diaChi}</p>
                        <label className="pt-control pt-radio pt5 pt-large checkbox-autocomplete">
                          <input type="radio" name="docs-radio-regular"/>
                          <span className="pt-control-indicator"></span>
                        </label>
                      </div>
                    </li>
                  )
                })
              }
              { this.state.page.totalElements > 3 ? (
                <li>
                  <Link className="btn-view-more" onClick={this.viewAllResult.bind(this, this.state.value)}>
                    Xem thêm {this.state.page.totalElements - 3} kết quả
                  </Link>
                </li>
              ) : null }
            </ul>
          </ShowIf>
        </div>
      </div>
    )
  }
}

AutoCompleteSearch.defaultProps = {
  isRequired: false,
  name: '',
  disabled: false
}

export default connect()(validatable(AutoCompleteSearch));



// WEBPACK FOOTER //
// ./src/components/modules/auto-complete/AutoCompleteSearch.jsx